import { config } from '../config/config';

// Type for translation URL mapping function
type TranslationUrlProvider = () => Record<string, string>;

/**
 * Web-specific implementation for getting translation URLs from environment variables
 * This is used only in the web app to read URLs from Vite's import.meta.env
 */
export const getTranslationUrls: TranslationUrlProvider = () => {
  return {
    'ro-RO': config.NX_PUBLIC_TRANSLATION_URL_RO_RO,
    'fr-FR': config.NX_PUBLIC_TRANSLATION_URL_FR_FR,
    'de-DE': config.NX_PUBLIC_TRANSLATION_URL_DE_DE,
    'ka-GE': config.NX_PUBLIC_TRANSLATION_URL_KA_GE,
    'cy-GB': config.NX_PUBLIC_TRANSLATION_URL_CY_GB,
    'nl-NL': config.NX_PUBLIC_TRANSLATION_URL_NL_NL,
    'it-IT': config.NX_PUBLIC_TRANSLATION_URL_IT_IT,
    'el-GR': config.NX_PUBLIC_TRANSLATION_URL_EL_GR,
    'es-ES': config.NX_PUBLIC_TRANSLATION_URL_ES_ES,
    'pt-PT': config.NX_PUBLIC_TRANSLATION_URL_PT_PT,
    'fi-FI': config.NX_PUBLIC_TRANSLATION_URL_FI_FI,
    'nb-NO': config.NX_PUBLIC_TRANSLATION_URL_NB_NO,
    'sv-SE': config.NX_PUBLIC_TRANSLATION_URL_SV_SE,
    'da-DK': config.NX_PUBLIC_TRANSLATION_URL_DA_DK,
    'pl-PL': config.NX_PUBLIC_TRANSLATION_URL_PL_PL,
    'lv-LV': config.NX_PUBLIC_TRANSLATION_URL_LV_LV,
    'lt-LT': config.NX_PUBLIC_TRANSLATION_URL_LT_LT,
    'cs-CZ': config.NX_PUBLIC_TRANSLATION_URL_CS_CZ,
    'sk-SK': config.NX_PUBLIC_TRANSLATION_URL_SK_SK,
    'et-EE': config.NX_PUBLIC_TRANSLATION_URL_ET_EE,
    'gu-IN': config.NX_PUBLIC_TRANSLATION_URL_GU_IN,
    'bn-BD': config.NX_PUBLIC_TRANSLATION_URL_BN_BD,
    'pa-IN': config.NX_PUBLIC_TRANSLATION_URL_PA_IN,
    'ur-PK': config.NX_PUBLIC_TRANSLATION_URL_UR_PK,
    'ar-AE': config.NX_PUBLIC_TRANSLATION_URL_AR_AE,
  };
};
